import { Task } from '../../../../../../../models/MeetingSupport'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../../models/AiResult'
import { User } from '../../../../../../../models/User'

import { CopyContent, HTML_TYPE, TEXT_TYPE } from '../../../../../../../common/copy'

import { CopyData, getEmptyResultCopyContent } from '../../../copy'
import { escapeHtml } from '../../../../common/aifeatures/utils'

export const copyTasks = (aiFeature: AiFeature, aiResult: AiResult, copyData?: CopyData): CopyContent => {
  const { groupedTasks } = copyData ?? {}
  if (!groupedTasks) {
    return getEmptyResultCopyContent()
  }
  return copyGroupedTasks(groupedTasks)
}

export const copyGroupedTasks = (groupedTasks: { user: User; tasks: Task[] }[]): CopyContent => {
  const copyPlainString = groupedTasks
    .map(({ user, tasks }) => {
      return `${user.name}: \n${tasks
        .map((task) => {
          const { task: subject, description } = task
          const descriptionPart = description ? `: ${description}` : ''
          return `\t- ${subject}${descriptionPart}`
        })
        .join('\n')}\n`
    })
    .join('')
  const copyHTMLString = groupedTasks
    .map(({ user, tasks }) => {
      return (
        `<p><strong>${escapeHtml(user.name ?? '')}</strong></p>` +
        (tasks.length ? `<ul><li>` : '') +
        `${tasks
          .map((task) => {
            const { task: subject, description } = task
            const descriptionPart = description ? `: ${description}` : ''
            return `${escapeHtml(subject)}${descriptionPart}`
          })
          .join('</li><li>')}` +
        (tasks.length ? `</li></ul>` : '') +
        ``
      )
    })
    .join('')
  return {
    [TEXT_TYPE]: copyPlainString,
    [HTML_TYPE]: copyHTMLString,
  }
}
